import type { BrowserOptions } from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { registerGlobalEventScrubbing, scrubSentryEvent } from './piiSanitizer';

const tracesSampleRate = process.env.RAILS_ENV === 'production' ? 0.01 : 0;

// beforeSend はエラーイベントのみに適用され、トランザクションイベント
// （BrowserTracing の pageload/navigation）には適用されない。トランザクション
// にも同じスクラブを適用するため、グローバルイベントプロセッサとして併用登録する。
registerGlobalEventScrubbing();

const sentryInitOption: BrowserOptions = {
  dsn: process.env.SENTRY_CLIENT_DSN,
  integrations: [new BrowserTracing()],
  ignoreErrors: [
    'FirebaseError',
    // Instagram / Facebook 等の in-app browser が注入する bridge
    //（sendDataToNative / sendPageHideMessage 等）が
    // window.webkit.messageHandlers を未定義のまま参照する既知ノイズ（実害なし）
    // 例: evaluating 'window.webkit.messageHandlers'
    //     evaluating 'window.webkit.messageHandlers[IOS_BRIDGE_NO_REPLY].postMessage'
    // cf. otetsutabi-next 側の同種対応（GEN-3450）
    /undefined is not an object \(evaluating ['"]window\.webkit\.messageHandlers/,
    // LINE 等 Android 版アプリ内ブラウザが注入する bridge
    //（sendDataToNative → iabjs://navigation_performance_logger_android）
    // からの postMessage 失敗。上記 window.webkit.messageHandlers の Android 版で、
    // 実害なし
    // 例: Error invoking postMessage: Java object is gone
    //     Error invoking postMessage: Java exception was raised during method invocation
    /^Error invoking postMessage:/,
  ],
  beforeSend: scrubSentryEvent,

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: tracesSampleRate,
};

export default sentryInitOption;
